import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { ChannelsService, VariableCircuitoOut, VariableCircuitoIn, ResponseConfiguration, ResponseInvocacionChannelSetting } from '../../../infrastructure/services/channels.service';

@Component({
    selector:"",
    templateUrl:"setting-channel.component.html"
})

export class SettingChannelComponent implements OnInit {
  codSubscription;
  codChannel;
  atributos;
  values = {};
  respuestaInvocacion: ResponseInvocacionChannelSetting;
  errores = {};
  mostrarRespuesta = false;
  constructor(private aRoute: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private confiChannel: ChannelsService ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      if(this.codSubscription===undefined &&
        this.codChannel===undefined){
          this.codSubscription = 'null';
          this.codChannel = 'null';
        }

      this.confiChannel.getAttributes(this.codSubscription, this.codChannel)
        .then(response => this.inicializarFormulario(response));
    });
  }

  enviar() {
    let form: VariableCircuitoIn[] = Object.keys(this.values).map(key => ({ codigo: key, valor: this.values[key] }));

    if (!this.formularioValido(form)) {
      return;
    }


    this.confiChannel
      .saveAttributes(this.codSubscription, this.codChannel, form)
      .then(res => {
        
        // La invocacion del comando fallo
        if (res.errores != null) {
          this.mostrarErrores(res.errores);
          return;
        }

        // Invocacion del comando exitosa
        this.respuestaInvocacion = res;

        this.alertService.showGrowl({
          body: this.respuestaInvocacion.msgResult,
          type: GrowlType.SUCCESS,
        });

        this.mostrarRespuesta = true;

        this.router.navigate([('../')], { relativeTo: this.aRoute });
        
      });
  }

  inicializarFormulario(response: ResponseConfiguration) {
    this.atributos = response.form;
    this.atributos.forEach(atributo => {
      if (atributo.tipo !== 'Custom') {
        this.values[atributo.codigo] = atributo.valorDefault;
      }
      if (atributo.tipo === 'DateTime') {
        this.values[atributo.codigo] = atributo.valorDefault; // .split('/').reverse().join('-')
      }
    });
  }

  /**
   * Wrapper de la funcion JSON.parse para poder
   * utilizarla dentro del template html
   */
  toObj(json: string) {
    return JSON.parse(json);
  }

  /**
   * Retorna el titutlo del atributo concatenado con (*)
   * en caso de que este sea obligatorio
   */
  getLabel(atributo: VariableCircuitoOut) {
    let label = atributo.titulo;
    if (!atributo.esOpcional) {
      label += ' (*)';
    }
    return label;
  }

  /**
   * Valida cada campo del formulario, checkeando los que
   * son obligatorios. Retorna true solo si cada campo
   * obligatorio fue ingresado.
   */
  formularioValido(form: VariableCircuitoIn[]): boolean {
    this.errores = {};
    if (this.atributos.length > 0) {
      return this.atributos
        .map(this.campoValido.bind(this, form))
        .reduce((current, total) => current && total);
    } else {
      return true;
    }
  }

  /**
   * Valida que el atributo pasado sea valido.
   */
  campoValido(form: VariableCircuitoIn[], atributo: VariableCircuitoOut): boolean {
    let esValido = true;
    const variable = form.find(atr => atr.codigo === atributo.codigo);

    if (!variable) {
      return true;
    }

    const valor = variable.valor;

    if (!atributo.esOpcional) {
      esValido = !!valor;
      if (!esValido) {
        this.errores[atributo.codigo] = 'VALOR_REQUERIDO';
      }
    }

    return esValido;
  }

  /**
   * Formatea un date obtenido de un input html
   * a un formato compatible con Datetime del backend
   * y lo almacena en el la lista de values
   *
   * @param value Valor proveniendo del input date (YYYY-MM-DD)
   * @param codigoAtributo Key para saber que campo se esta actualizando
   */
  formatDate(value, codigoAtributo) {
    const splitedDate = value.split('-');
    this.values[codigoAtributo] = value; // splitedDate.reverse().join('/');
  }

  mostrarErrores(errores) {
      this.alertService.showGrowl({
        body: errores,
        type: GrowlType.DANGER,
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/setting-channel/setting-channel.component.ts